import { render, staticRenderFns } from "./TopNavbarNew.vue?vue&type=template&id=1685b882&scoped=true&"
import script from "./TopNavbarNew.vue?vue&type=script&lang=js&"
export * from "./TopNavbarNew.vue?vue&type=script&lang=js&"
import style0 from "./TopNavbarNew.vue?vue&type=style&index=0&id=1685b882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685b882",
  null
  
)

export default component.exports